import React from 'react';
import ImageOnlyView from './ImageOnlyView';
import FullView from './FullView';
import StoryWithImage from './StoryWithImage';

function ContentRenderer({ layout, imagePosition, hasImages, realmObjectID, realmObject }) {
  switch (layout) {
    case 'image-only':
      return <ImageOnlyView {...{ hasImages, realmObjectID, realmObject }} />;
    case 'long-story':
      return <StoryWithImage fieldKey="LongStory" {...{ imagePosition, hasImages, realmObjectID, realmObject }} />;
    case 'short-story':
      return <StoryWithImage fieldKey="ShortStory" {...{ imagePosition, hasImages, realmObjectID, realmObject }} />;
    case 'full':
    default:
      return <FullView {...{ hasImages, realmObjectID, realmObject }} />;
  }
}

export default ContentRenderer;
